import Axios from "../../../../api/axios/Axios";

const creatorGroupsUrl = (username) =>
  `/api/creators/${encodeURIComponent(username)}/groups`;

const creatorGroupUrl = (username, groupTag) =>
  `${creatorGroupsUrl(username)}/${encodeURIComponent(groupTag)}`;

const creatorGroupMembersUrl = (username, groupTag) =>
  `${creatorGroupUrl(username, groupTag)}/members`;

export const getCreatorGroups = (username) =>
  Axios.get(creatorGroupsUrl(username));

export const getCreatorGroup = (groupTag, username) =>
  Axios.get(creatorGroupUrl(username, groupTag));

export const createCreatorGroup = (username, data) =>
  Axios.post(creatorGroupsUrl(username), data);

export const updateCreatorGroup = (groupTag, username, data) =>
  Axios.put(creatorGroupUrl(username, groupTag), data);

export const deleteCreatorGroup = (groupTag, username) =>
  Axios.delete(creatorGroupUrl(username, groupTag));

export const getCreatorGroupMembers = (groupTag, username, status = "all") =>
  Axios.get(creatorGroupMembersUrl(username, groupTag), {
    params: { status },
  });

export const getCreatorGroupMemberCount = (groupTag, username) =>
  Axios.get(`${creatorGroupMembersUrl(username, groupTag)}/count`);

export const updateCreatorGroupMemberStatus = (
  groupTag,
  username,
  memberId,
  status,
) =>
  Axios.put(
    `${creatorGroupMembersUrl(username, groupTag)}/${encodeURIComponent(memberId)}/status`,
    { status },
  );

export const removeCreatorGroupMember = (groupTag, username, memberId) =>
  Axios.delete(
    `${creatorGroupMembersUrl(username, groupTag)}/${encodeURIComponent(memberId)}`,
  );

export const getGroupContent = (groupTag, params = {}) =>
  Axios.get(`/api/groups/${encodeURIComponent(groupTag)}/content`, {
    params,
  });
